import { Input } from '@bb/ui';
import { useState, type InputHTMLAttributes } from 'react';

const format = (value: number | undefined) => (value === undefined || !Number.isFinite(value) ? '' : String(value));
const parse = (text: string) => (text.trim() === '' ? undefined : Number(text));

/** A number field that keeps the typed text while the number it means stays the same; empty means no number. */
export function NumberInput({ value, onValueChange, ...rest }: { value: number | undefined; onValueChange: (value: number | undefined) => void } & Omit<InputHTMLAttributes<HTMLInputElement>, 'value' | 'onChange' | 'type'>) {
  const [text, setText] = useState(() => format(value));
  const [synced, setSynced] = useState(value);
  if (!Object.is(value, synced)) {
    setSynced(value);
    if (!Object.is(parse(text), value)) setText(format(value));
  }
  return (
    <Input
      {...rest}
      type="number"
      value={text}
      onChange={(e) => {
        setText(e.target.value);
        onValueChange(parse(e.target.value));
      }}
    />
  );
}
